/*Custom JS Assets by PurplePanda Ecom*/

// Create a class for the custom element
class InstagramSlider extends HTMLElement {
  constructor() {
    super(); // Call the super() method first in the constructor
  }

  // Specify what happens when the element is connected to the DOM
  connectedCallback() {
    this.element = this.querySelector(".swiper");
    this.buttons = document.querySelectorAll(
      `[aria-controls="${this.getAttribute("id")}"]`
    );
    this.closeButton = this.querySelector("[data-close]");
    this.init();
  }

  createBullets(slide) {
    this.bulletContainer = this.querySelector(".story-bullets");
    this.bulletContainer.innerHTML = "";
    if (!slide) {
      this.slide = this.querySelector(".swiper-video-list");
    } else {
      this.slide = slide.querySelector(".swiper-video-list");
    }

    let amount = this.slide.children.length;
    for (let i = 0; i < amount; i++) {
      let templateNode = document.createElement("div");
      templateNode.classList.add("story-bullet");
      templateNode.setAttribute("data-index", i);
      templateNode.innerHTML = `<div data-progress class="story-bullet-grow" style="--width: 0%;">`;
      this.bulletContainer.appendChild(templateNode);
    }
  }

  open() {
    if (this.closest("safe-sticky")) {
      this.closest("safe-sticky").classList.add("zhigh");
    }
    this.removeAttribute("hidden");
  }

  close() {
    this.setAttribute("hidden", true);
    this.destroySwiper();
    if (this.closest("safe-sticky")) {
      this.closest("safe-sticky").classList.remove("zhigh");
    }
  }

  init() {
    let that = this;
    this.videos = this.querySelectorAll("video");
    this.videos.forEach((video) => {
      video
        .closest(".story__slide")
        .setAttribute("data-swiper-autoplay", video.duration * 1000);
    });
    this.buttons.forEach((button) => {
      button.addEventListener("click", () => {
        button.classList.add("active");
        setTimeout(() => {
          this.open();
          this.initSwiper();
          button.classList.remove("active");
        }, 500);
      });
    });
    this.closeButton.addEventListener("click", () => {
      this.close();
    });
  }

  initSwiper(toSlide) {
    let that = this;
    this.querySelectorAll(".swiper-video-list").forEach(
      (videoContainer, index) => {
        videoContainer.querySelectorAll("video").forEach((video) => {
          video.setAttribute("hidden", true);
          video.removeAttribute("playing");
        });
        videoContainer.querySelector("video").removeAttribute("hidden");
      }
    );
    this.swiperElement = new Swiper(this.element, {
      speed: 1,
      watchSlidesProgress: true,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next.next",
        prevEl: ".swiper-button-prev.prev",
      },
      rewind: false,
      slidesPerView: 1,
      on: {
        init(swiper) {
          that.stopAllVideos();
          that.loopVideos(
            this.slides[swiper.activeIndex].querySelectorAll("video"),
            swiper
          );
        },
      },
    });
  }

  loopVideos(videoArray, swiper) {
    this.videoArray = videoArray;
    this.currentSlide = swiper.slides[swiper.activeIndex];
    this.createBullets(swiper.slides[swiper.activeIndex]);
    for (const [index, video] of videoArray.entries()) {
      let currentLength = video.duration;
      this.bulletContainer.children[index].querySelector(
        "[data-progress]"
      ).style.transitionDuration = currentLength + "s";

      video.onended = (event) => {
        video.setAttribute("hidden", true);
        if (videoArray[index + 1]) {
          this.currentVideo = videoArray[index + 1];
          this.playCurrentVideo();
          this.currentVideoIndex = index + 1;
        } else {
          this.close();
        }
      };
    }
    this.currentVideo = videoArray[0];
    this.currentVideoIndex = 0;
    this.playCurrentVideo();
  }

  playCurrentVideo() {
    for (let i = 0; i < this.currentVideoIndex; i++) {
      this.bulletContainer
        .querySelectorAll("[data-progress]")
        [i].closest(".story-bullet")
        .classList.add("done");
    }
    this.currentVideo.currentTime = 0;
    this.currentVideo.removeAttribute("hidden");
    this.currentVideo.setAttribute("playing", true);
    this.currentVideo.play();
    setTimeout(() => {
      this.bulletContainer
        .querySelectorAll("[data-progress]")
        [this.currentVideoIndex].classList.add("playing");
    }, 2);
  }

  stopVideos() {
    this.videoArray.forEach((video) => {
      video.pause();
      video.currentTime = 0;
      this.currentVideo.removeAttribute("playing");
      video.setAttribute("hidden", true);
    });
  }

  stopAllVideos() {
    this.querySelectorAll("video").forEach((video) => {
      video.pause();
      video.currentTime = 0;
      video.setAttribute("hidden", true);
    });
  }

  handleNext() {
    if (!this.videoArray) {
      return;
    }
    this.stopVideos();
    if (this.videoArray[this.currentVideoIndex + 1]) {
      this.currentVideo = this.videoArray[this.currentVideoIndex + 1];
      this.currentVideoIndex = this.currentVideoIndex + 1;
      this.playCurrentVideo();
    } else {
      this.stopVideos();
      this.checkNextSlide();
    }
  }

  handlePrev() {
    if (!this.videoArray) {
      return;
    }
    this.stopVideos();
    if (this.videoArray[this.currentVideoIndex - 1]) {
      this.currentVideo = this.videoArray[this.currentVideoIndex - 1];
      this.currentVideoIndex = this.currentVideoIndex - 1;
      this.playCurrentVideo();
    } else {
      this.stopVideos();
      this.close();
    }
  }

  checkNextSlide() {
    this.swiperElement.slideNext();
  }

  checkPrevSlide() {
    this.swiperElement.slidePrev();
  }

  destroySwiper() {
    this.swiperElement.destroy();
    this.videos.forEach((video) => {
      video.pause();
    });
  }
}

import { TextWithIconsCarousel } from "theme";
var MediaGridCarousel = class extends TextWithIconsCarousel {
  constructor() {
    super();
  }
};
if (!window.customElements.get("media-grid-carousel")) {
  window.customElements.define("media-grid-carousel", MediaGridCarousel);
}

class ExternalLinkTargetBlank {
  constructor() {
    // Call the method to add target="_blank" to external links when the page loads
    if (document.body.hasAttribute("data-externals")) {
      window.onload = this.addTargetBlankToExternalLinks.bind(this);
      console.warn("External Links activated");
    } else {
      console.log("External Links deactivated");
    }
  }

  // Function to check if a URL is external
  isExternal(url) {
    // Create an anchor element
    var anchor = document.createElement("a");
    anchor.href = url;

    // Check if the hostname of the URL is different from the current hostname
    return (
      anchor.hostname !== window.location.hostname &&
      anchor.protocol.startsWith("http")
    );
  }

  // Function to add target="_blank" attribute to external links
  addTargetBlankToExternalLinks() {
    // Get all anchor elements on the page
    var links = document.getElementsByTagName("a");

    // Loop through each link
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      // Check if the link is not an internal link and doesn't start with '#'
      if (this.isExternal(link.href) && !link.href.startsWith("#")) {
        // Add target="_blank" attribute to external links
        link.setAttribute("target", "_blank");
      }
    }
  }
}

class VariantMetafields extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.data = JSON.parse(this.getAttribute("data-json"));
    if (this.data) {
      this.handleChange = this.handleChange.bind(this);
      document.addEventListener("variant:change", this.handleChange);
    }
  }

  handleChange(event) {
    let searchID = event.detail.variant.id.toString();
    if (this.data[searchID]) {
      this.innerText = this.data[searchID];
    }
  }

  disconnectedCallback() {
    document.removeEventListener("variant:change", this.handleChange);
  }
}

class VariantMetafieldImages extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.data = JSON.parse(this.getAttribute("data-images"));
    this.links = JSON.parse(this.getAttribute("data-links"));
    this.popups = JSON.parse(this.getAttribute("data-popups"));

    this.image = this.querySelector("[data-image]");
    if (this.data) {
      this.handleChange = this.handleChange.bind(this);
      this.image.removeAttribute("srcset");
      document.addEventListener("variant:change", this.handleChange);
      this.addEventListener("click", this.handleClick.bind(this));
    }
  }

  handleChange(event) {
    let searchID = event.detail.variant.id.toString();
    if (this.data[searchID]) {
      this.classList.remove("hidden");
      this.image.src = this.data[searchID];
    } else {
      this.classList.add("hidden");
    }

    //Check if a Popup or Link exists

    this.classList.remove("cursor-pointer");
    this.removeAttribute("data-link");
    this.removeAttribute("data-popup");

    if (this.popups && this.popups[searchID]) {
      this.classList.add("cursor-pointer");
      this.setAttribute("data-popup", this.popups[searchID]);
      return;
    }

    if (this.links && this.links[searchID]) {
      this.classList.add("cursor-pointer");
      this.setAttribute("data-link", this.links[searchID]);
    }
  }

  handleClick(e) {
    if (this.getAttribute("data-popup")) {
      let modal = document.getElementById(this.getAttribute("data-target"));
      let image = document.createElement("img");
      image.src = this.getAttribute("data-popup");
      if (modal) {
        modal.querySelector(".prose").innerHTML = "";
        modal.querySelector(".prose").append(image);
        modal.show();
      }
      return;
    }

    if (this.getAttribute("data-link")) {
      window.location.href = this.getAttribute("data-link");
    }
  }

  disconnectedCallback() {
    document.removeEventListener("variant:change", this.handleChange);
  }
}

import { ProductForm, CartDrawer } from "theme";
class ProductFormUpsell extends ProductForm {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.getAttribute("inited") === "true") {
      return;
    }

    this.setAttribute("inited", true);

    this.originalFormId = document.forms[this.getAttribute("original-form")].id;
    this.CartDrawer = this.querySelector("cart-drawer");
    this.querySelector('[href="#"]').addEventListener(
      "click",
      this.handleSubmit.bind(this)
    );
  }

  disconnectedCallback() {
    this.querySelector('[href="#"]').removeEventListener(
      "click",
      this.handleSubmit.bind(this)
    );
  }

  async handleSubmit(e) {
    e.preventDefault();
    this.data = new FormData(this);
    this.data.append("id[]", this.data.get("id"));
    this.data.delete("id");
    this.data.append("id[]", this.originalFormId.value);

    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true })
    );
    let response = await this.pushForm(this.data);
    console.log(response);
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:end", { bubbles: true })
    );
    document.dispatchEvent(
      new CustomEvent("cart:refresh", { detail: { open: true } })
    );
  }

  async pushForm(data) {
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: data,
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    return response;
  }
}

class UpsellCheckbox extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.input = this.querySelector("select");
  }

  connectedCallback() {
    this.checkbox.addEventListener("change", this.handleChange.bind(this));
  }

  disconnectedCallback() {
    this.checkbox.removeEventListener("change", this.handleChange.bind(this));
  }

  handleChange(e) {
    if (e.target.checked) {
      this.input.setAttribute("form", this.getAttribute("data-form"));
    } else {
      this.input.removeAttribute("form");
    }
  }
}

//------------------------///

class UpsellListItem extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.input = this.querySelector("select");
    this.variants = JSON.parse(this.getAttribute("data-product")).variants;
    this.image = this.querySelector("img");
    this.productFormID = document.forms[
      this.getAttribute("data-target")
    ]?.addEventListener("variant:change", this.handleVariantChange.bind(this));
    this.productFormButton = document.forms[this.getAttribute("data-target")]
      ?.querySelector(".button")
      .addEventListener("click", this.handleModalClick.bind(this));
    this.removeButton = this.querySelector("[data-remove] .button");
    this.openModalButton = this.querySelector("[aria-controls]");
    if (this.openModalButton) {
      this.ModalForm = document.forms[this.getAttribute("data-target")];
      this.openModalButton.addEventListener(
        "click",
        this.addFirstVariant.bind(this)
      );
    }
    if (this.removeButton) {
      this.removeButton.addEventListener("click", this.removeItem.bind(this));
    }
  }

  addFirstVariant(e) {
    let id = this.ModalForm.id.value;
    let selectedVariant = this.variants.find(
      (variant) => variant.id === parseInt(id)
    );
    if (selectedVariant) {
      this.image.src = selectedVariant.featured_image.src;
      this.image.removeAttribute("srcset");
      this.triggerInputValue(true);
    }
  }

  connectedCallback() {
    this.checkbox.addEventListener("change", this.handleChange.bind(this));
    this.input.addEventListener("change", this.handleChangeSelect.bind(this));

    this.addEventListener("click", this.handleLabelClick.bind(this));
  }

  handleLabelClick(e) {
    if (!this.checkbox.checked && !e.target.closest("button")) {
      if (this.openModalButton) {
        this.openModalButton.click();
      }
    }
  }

  disconnectedCallback() {
    this.checkbox.removeEventListener("change", this.handleChange.bind(this));
  }

  setSelectorValue(value) {
    this.input.value = value;
    this.input.dispatchEvent(new Event("change"));
  }

  removeItem(e) {
    this.checkbox.checked = false;
    this.input.removeAttribute("form");
  }

  triggerInputValue(value) {
    console.log("CHeckbox triggered", value);
    this.checkbox.checked = value;
    this.checkbox.dispatchEvent(new Event("change"));
  }

  handleModalClick(e) {
    let value = e.target
      .closest("form")
      .querySelector('input[name="id"]').value;
    if (value) {
      this.setSelectorValue(value);
      this.triggerInputValue(true);
    }
  }

  handleChange(e) {
    e.preventDefault();
    let otherCardsClicked = document.querySelectorAll(
      `[is="upsell-list-item"][data-sibling-id="${this.getAttribute(
        "data-sibling-id"
      )}"]:has(input:checked)`
    );
    let otherCards = document.querySelectorAll(
      `[is="upsell-list-item"][data-sibling-id="${this.getAttribute(
        "data-sibling-id"
      )}"]`
    );
    let maxChecks = parseInt(this.getAttribute("maximum-amount"));

    this.setAttribute(
      "data-clicked",
      Math.floor(new Date(new Date()).getTime() / 1000)
    );

    if (maxChecks && otherCardsClicked.length > maxChecks) {
      let cardsToRemoveAmount = otherCardsClicked.length - maxChecks;

      let sortedCards = Array.from(otherCardsClicked).sort((a, b) => {
        return (
          parseInt(a.getAttribute("data-clicked")) -
          parseInt(b.getAttribute("data-clicked"))
        );
      });

      // Skip the most recent one (last in the sorted list)
      sortedCards = sortedCards.slice(0, -1);

      // Remove the oldest cards up to the required amount
      sortedCards.slice(0, cardsToRemoveAmount).forEach((cardToRemove) => {
        console.log(cardToRemove);
        cardToRemove.querySelector('input[type="checkbox"]').checked = false;
        cardToRemove.querySelector("select").removeAttribute("form");
      });
    }

    if (e.target.checked) {
      this.input.setAttribute("form", this.getAttribute("data-form"));
    } else {
      this.input.removeAttribute("form");
      this.removeAttribute("data-clicked");
    }
  }

  handleChangeSelect(e) {
    console.log("Select change triggered");
    let id = e.target.value;
    if (!id) {
      console.log("No ID Identified");
      this.triggerInputValue(false);
      return;
    }
    let selectedVariant = this.variants.find(
      (variant) => variant.id === parseInt(id)
    );
    if (selectedVariant) {
      this.image.src = selectedVariant.featured_image.src;
      this.image.removeAttribute("srcset");
      this.triggerInputValue(false);
    } else {
      this.triggerInputValue(true);
    }
  }

  handleVariantChange(e) {
    if (e.detail.variant?.id) {
      this.setSelectorValue(e.detail.variant.id.toString());
      this.triggerInputValue(true);
    }
  }
}

class UVPPrice extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.forms[this.getAttribute("form")]?.addEventListener(
      "variant:change",
      this.handleVariantChange.bind(this)
    );
    this.prices = JSON.parse(this.getAttribute("data-json"));
  }
  disconnectedCallback() {
    document.forms[this.getAttribute("form")]?.removeEventListener(
      "variant:change",
      this.handleVariantChange.bind(this)
    );
  }

  handleVariantChange(e) {
    console.log(this.prices);
    let price = this.prices[e.detail.variant.id];
    if (price) {
      this.innerHTML = `UVP: ${formatMoney(price).split(",")[0]}`;
    } else {
      this.innerHTML = "";
    }
  }
}

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      ),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

class twoGrid extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.items = this.querySelectorAll(".grid--item");
    let that = this;
    this.items.forEach((item) => {
      item.addEventListener("click", this.handleClick.bind(this));
    });
  }

  handleClick(e) {
    console.log(e);
    let modal = document.getElementById(this.getAttribute("data-target"));
    let image = e.target.closest(".grid--item").querySelector(".hidden");
    const newImage = document.createElement("img");
    newImage.src = image.src;
    if (modal) {
      modal.querySelector(".prose").innerHTML = "";
      modal.querySelector(".prose").append(newImage);
      modal.show();
    }
    return;
  }
}

class optionsFilter extends HTMLElement {
  constructor() {
    super();
    this.productVariantSwatches =
      this.closest(".product").querySelector("variant-picker");
    this.subtitleElement = this.querySelector("[data-subtitles]");
    if (this.subtitleElement) {
      this.subtitles =
        JSON.parse(this.subtitleElement.getAttribute("data-texts")) || null;
      if (this.subtitles.length) {
        this.subtitles = this.subtitles.map((title) => {
          return title.replace("\n", "");
        });
      }
    }
    document.addEventListener('variant:change', this.handleVariantChange.bind(this));
    this.querySelectorAll("[data-group]").forEach((filter) => {
      filter.addEventListener("click", this.handleFilterChange.bind(this));
    });
  }
  connectedCallback() {
    this.init(null);
  }

  handleVariantChange(e){
    let selectedVariant = e.detail.variant;
    for (const option of selectedVariant.options){
      let clickedSwatch = this.productVariantSwatches.querySelector(`[value="${option}"]`);
      if(clickedSwatch){
        let label = document.querySelector(`[for="${clickedSwatch.getAttribute('id')}"]`);
        if(label && label.hasAttribute('data-group')){
          this.selectButton(label.getAttribute('data-group'));
        }
      }
    }

    this.restyleSwatches()
  }

  restyleSwatches(){
    let currentOption = this.querySelector('.is-active').getAttribute('data-group').toLowerCase();
    this.productVariantSwatches.querySelectorAll('[data-group]').forEach((swatch) => {
      if(swatch.getAttribute('data-group').toLowerCase() === currentOption){
        swatch.removeAttribute('data-hidden');
      }else{
        swatch.setAttribute('data-hidden', true);
      }
    });
  }

  selectButton(groupString){
    this.querySelectorAll('[data-group]').forEach((button) => {
      if(button.getAttribute('data-group').toLowerCase() === groupString.toLowerCase()){
        button.classList.add('is-active');
        let index = parseInt(button.getAttribute("data-index"));
        this.subtitleElement.innerText = this.subtitles[index];
      }else{
        button.classList.remove('is-active')
      }
    })
  }

  init(e) {
    this.handleFilterChange(null,);
  }

  handleFilterChange(e = null) {
    let button =
      e?.target.closest(".option-image") || this.querySelector(".is-active");

    this.querySelectorAll("[ data-group]").forEach((btn) => {
      btn.classList.remove("is-active");
    });
    if (button.hasAttribute("data-group")) {
      this.productVariantSwatches
        .querySelectorAll("[data-group]")
        .forEach((swatch) => {
          if (
            swatch.getAttribute("data-group").toLowerCase() ===
            button.getAttribute("data-group").toLowerCase()
          ) {
            swatch.removeAttribute("data-hidden");
          } else {
            swatch.setAttribute("data-hidden", true);
          }
        });
    }
    button.classList.add("is-active");

    if (button.getAttribute("data-index") && this.subtitles) {
      let index = parseInt(button.getAttribute("data-index"));
      this.subtitleElement.innerText = this.subtitles[index];
    }
    this.selectActiveSwatch()
  }

  selectActiveSwatch(){
    let activeValue = this.querySelector('.is-active').getAttribute('data-group').toLowerCase();
    let selectedSwatch = false;
    this.productVariantSwatches.querySelectorAll(`[data-group]`).forEach((swatch) => {
      if(swatch.getAttribute('data-group').toLowerCase() === activeValue && selectedSwatch === false){
        swatch?.click()
        selectedSwatch = true;
      }
    })
  }
}


function debugAnchorLink() {
  let anchorLink = document.querySelector(`[href="#strong-spezifikationen-strong-accordion"]`);
  console.log(anchorLink);
  if(anchorLink){
    anchorLink.addEventListener('click', (e) => {
      if (window.innerWidth > 1024) {
        e.preventDefault();
        console.log('CustomScroll');
        const target = document.getElementById('strong-spezifikationen-strong-accordion');
        
        const rect = target.getBoundingClientRect();
        const galleryRect = document.querySelector('.product product-gallery').getBoundingClientRect();
        let galleryHeight = document.querySelector('.product product-gallery').scrollHeight;
        let headerHeight = document.querySelector('.header').scrollHeight;
        let scrollOfGallery = galleryRect.bottom - (window.innerHeight * 0.5);
        
        console.log(rect.top,document.querySelector('.product product-gallery').scrollHeight, scrollOfGallery )

        window.scrollTo({
          top: scrollOfGallery,
          behavior: 'smooth'
        });
      }
    });
  }
}


document.addEventListener("DOMContentLoaded", () => {
  customElements.define("instagram-story", InstagramSlider);
  customElements.define("variant-metafields", VariantMetafields);
  customElements.define("metafield-image", VariantMetafieldImages);
  customElements.define("option-filter", optionsFilter);

  customElements.define("product-form-upsell", ProductFormUpsell, {
    extends: "form",
  });
  customElements.define("upsell-checkbox", UpsellCheckbox);
  customElements.define("upsell-list-item", UpsellListItem);
  customElements.define("uvp-price", UVPPrice);
  customElements.define("two-grid", twoGrid);

  new ExternalLinkTargetBlank();

  debugAnchorLink();
});


